import { c as _c } from "react/compiler-runtime";
import { BulkSuccessDialog } from "@components/common/faro-table/bulk-dialog/bulk-success-dialog";
import { useDeleteSnapshotsBulkDialogContent } from "@pages/project-details/project-snapshots/bulk-actions/bulk-delete-snapshots-helper";
import { useAppSelector } from "@store/store-helper";
import { bulkActionNameSelector, shouldShowSuccessDialogSelector } from "@store/table/table-selector";

/**
 * Renders the success dialog shown after a successful snapshots bulk-delete.
 *
 * It is rendered at the page level (instead of inside the bulk-action buttons)
 * so it survives the table unmounting when all snapshots are deleted and the
 * empty page is shown. Otherwise the success dialog would be lost and only
 * reappear later, once the table re-mounts.
 */
export function BulkDeleteSnapshotsSuccessDialog() {
  const $ = _c(2);
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  const shouldShowSuccessDialog = useAppSelector(shouldShowSuccessDialogSelector);
  const {
    successDialogContent
  } = useDeleteSnapshotsBulkDialogContent();
  if (bulkActionName !== "deleteSnapshots" || !shouldShowSuccessDialog) {
    return null;
  }
  let t0;
  if ($[0] !== successDialogContent) {
    t0 = <BulkSuccessDialog dialogContent={successDialogContent} />;
    $[0] = successDialogContent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}